import * as actions from './actions'

const catalogBiologicalSexesModule = {
    namespaced: true,
    actions,
}

export default catalogBiologicalSexesModule
